import { useProvider } from "../../../contexts/ProviderContext";
import {
  useUserContext,
  type CloudCostType,
} from "../../../contexts/UserContext";

/**
 * Hook that returns the cost reporting configuration for the currently selected provider
 * @returns The CloudCostType for the current provider, or undefined if not available
 */
export function useCostReportingConfig(): CloudCostType | undefined {
  const { costReportingConfig } = useUserContext();
  const provider = useProvider();

  // Map provider to the corresponding cost type
  switch (provider) {
    case "aws":
      return costReportingConfig.awsCostType;
    case "azure":
      return costReportingConfig.azureCostType;
    case "gcp":
      return costReportingConfig.gcpCostType;
    case "tencentcloud":
    case "k8s":
      // These providers don't have cost reporting config yet
      return undefined;
    default:
      return undefined;
  }
}

/**
 * Formats a CloudCostType into a user-friendly display string
 * @param costType - The cost type to format
 * @returns A formatted string suitable for UI display
 */
export function formatCostType(costType: CloudCostType | undefined): string {
  switch (costType) {
    case "BilledCost":
      return "Billed Cost";
    case "EffectiveCost":
      return "Effective Cost";
    case "ListCost":
      return "List Cost";
    default:
      return "Effective Cost";
  }
}
